module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"label":"상품옵션별 리뷰 보기","description":"*표시된 리뷰수는 계산 시점에 따라 실제 리뷰수와 차이가 있을 수 있습니다."}}')
  delete Component.options._Ctor
}
